module.exports = __webpack_public_path__ + "static/img/favourite-selected.57bcfe9.png";